import React from 'react';
import { FiArrowRight, FiPlay } from 'react-icons/fi';

function Hero() {
  return (
    <section className="hero">
      <div className="hero-content animate-fade-in">
        <span className="hero-badge">✨ Desenvolvimento & Qualidade</span>
        <h1>Do código ao conteúdo: sua presença digital completa</h1>
<p>Desenvolvimento web, marketing digital e estratégia de conteúdo. 
   Tudo que seu negócio precisa para crescer online, em um só lugar.</p>
        <div className="hero-buttons">
          <a href="#contato" className="btn btn-primary">
            Começar Projeto <FiArrowRight />
          </a>
          <a href="#demos" className="btn btn-secondary">
            Ver Desmonstrações <FiPlay />
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;